import {
  PromoCode,
  PromoCodeSearchParams,
} from '@fantaz/shared/data-access/models';
import { createAction, props } from '@ngrx/store';

export const loadPromoteCodes = createAction(
  '[PromoCode Page] Load Promo Codes',
  props<{ params: PromoCodeSearchParams }>(),
);

export const loadFromLocalStorage = createAction(
  '[PromoCode Page] load From Local Storage',
);

export const loadPromoCodesSuccess = createAction(
  '[PromoCode/API] Load Promo Codes Success',
  props<{ promoCodes: PromoCode[]; total: number }>(),
);

export const loadPromoCodesFailure = createAction(
  '[PromoCode/API] Load Promo Codes Failure',
  props<{ error: any }>(),
);

export const confirmPromoCode = createAction(
  '[PromoCode Page] Confirm Promo Codes',
  props<{ promoCodeId: string; reload?: boolean }>(),
);

export const confirmPromoCodeSuccess = createAction(
  '[PromoCode/API] Confirm Promo Codes Success',
  props<{
    promoCode: PromoCode;
    code: string;
    options?: { onboarding?: boolean; reload?: boolean; sponsor?: string };
  }>(),
);

export const confirmPromoCodeFailure = createAction(
  '[PromoCode/API] Confirm Promo Codes Failure',
  props<{ error: any; promoCode: string }>(),
);

export const sendPromoCodeGA = createAction(
  '[PromoCode/GA] Send Promo Code GA',
  props<{
    promoCode: PromoCode;
    onboarding?: boolean;
    sponsor?: string;
    options?: {
      disabledRedirect?: boolean;
    };
  }>(),
);
